<template>
  <div v-if="isVisible" class="dispatch-modal-overlay">
    <div class="dispatch-modal-container">
      <div class="dispatch-modal-header" >
        <div class="dispatch-header-title" :style="'min-width: ' + getWidth">
          <h1>{{ current.title }}</h1>
          <img src="/static/img/Sparkling-purple.svg">
        </div>
        <div class="header-actions">
          <img src="/static/img/arrow-left.svg" @click="prev">
          <img src="/static/img/gray_x.svg">
        </div>
      </div>
      <div class="dispatch-modal-body">
        <component
          :is="current.component"
          :step="step"
          :toast="this.$refs.toast"
          :weightBalance="weightBalance"
          :flightDetails="flightDetails"
          @next="next"
        />
      </div>
    </div>

    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import ToastNotifier from "@/components/ToastNotifier.vue";
import FlightPlanDisclaimer from './FlightPlanDisclaimer.vue';
import FlightMainDetails from './FlightMainDetails.vue';
import WeightBalance from './WeightBalance.vue';
import WeightBalanceEnvelope from './WeightBalanceEnvelope.vue';
import FlightOtherDetails from './FlightOtherDetails.vue';
import PilotReadinessChecklists from './PilotReadinessChecklists.vue';
import AircraftMainChecklists from './AircraftMainChecklists.vue';
// import AircraftOtherChecklists from './AircraftOtherChecklists.vue'; --> to be use soon
import PaveWorksheet from './PaveWorksheet.vue';
import FlightSummary from './FlightSummary.vue';
import { DISPATCHER_POPUPS } from '../../util/constants.js';
export default {
  components: {
    ToastNotifier,
    FlightPlanDisclaimer,
    FlightMainDetails,
    WeightBalance,
    WeightBalanceEnvelope,
    FlightOtherDetails,
    PilotReadinessChecklists,
    AircraftMainChecklists,
    // AircraftOtherChecklists,
    PaveWorksheet,
    FlightSummary
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      step: 1,
      weightBalance: {},
      flightDetails: {},
      formData: {}
    }
  },
  computed: {
    current() {
      return this.components[this.step - 1];
    },
    getWidth() {
      return (this.step === 1 || this.step === 9)
        ? '650px' : '500px';
    },
    components() {
      const defaultComponent = {
        title: 'Flight Plan Disclaimer and Liability',
        component: 'FlightPlanDisclaimer'
      };

      const isExist = DISPATCHER_POPUPS.some(x => x.component === defaultComponent.component);
      const components = DISPATCHER_POPUPS;

      if(!isExist) components.unshift(defaultComponent);

      return components;

    }
  },
  methods: {
    next(data) {
      if(this.step < this.components.length) {

        if(data) {
          if(data.tw && data.lw) {
            this.weightBalance.weightBalanceData = data.weightBalance
            delete data.weightBalance
            const { tw, lw } = data;
            this.weightBalance.tw = tw;
            this.weightBalance.lw = lw;
          }
          // Capture flight details
          if (this.step === 2) { // Assuming step 2 is FlightMainDetails
            this.flightDetails = { ...data };
          }

          // Weight Balance return values
          if (data.tw || data.lw) {
            this.weightBalance.tw = data.tw;
            this.weightBalance.lw = data.lw;
          }
        }

          // gather data here: wip

        this.step++;
      } else alert('Submitted')
    },
    prev() {
      if(this.step > 1) {
        this.step--;
      }
    }
  }
}
</script>
<style>
.dispatch-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 999;
}
.dispatch-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 20px;
  border: none !important;
  margin-bottom: 20px;
}
.dispatch-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dispatch-header-title h1 {
  font-size: 22px;
  font-weight: bold;
  margin: 0;
}
.dispatch-header-title img {
  height: 20px;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}
.header-actions img {
  cursor: pointer;
}
.dispatch-modal-container {
  background: #fff;
  padding: 10px;
  position: relative;
  border-radius: 10px;
}

.dispatch-modal-body {
  padding: 0px 18px 20px 18px;
  background: #fff;
  max-height: 750px;
  overflow-x: auto;
}
button.primary {
  width: 100%;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 600;
}
</style>
